/* SpawnAnything — recorded battle sounds (Kenney "Impact Sounds", "Sci-fi Sounds", CC0; guns: Vincent Sevedge, CC BY 3.0 —
   see public/sfx/CREDITS.txt).
   Mono AAC files public/sfx/<set>_<i>.m4a, loudness-normalised (-18 LUFS). A sound name listed here plays a random
   recorded variant; everything else (bows, rockets, music, UI …) keeps its synth voice from synth.js, which is also the
   fallback while the files load or if one fails. rate: playback-rate factor, gain: level relative to the synth. */

/** sound name -> { set (file prefix), n (files), rate, gain } */
export const SAMPLE_SETS = {
  clash: { set: 'clash', n: 6, gain: 0.85 },
  punch: { set: 'punch', n: 4, gain: 0.9 },
  bonk: { set: 'bonk', n: 4, gain: 0.9 },
  bhit: { set: 'bhit', n: 4, gain: 0.9 },
  poof: { set: 'poof', n: 4, gain: 0.7 },
  expl_small: { set: 'expl_small', n: 5, gain: 1 },
  expl_big: { set: 'expl_big', n: 2, gain: 1 },
  nuke: { set: 'expl_big', n: 2, rate: 0.6, gain: 1.1 },
  collapse: { set: 'expl_big', n: 2, rate: 0.8, gain: 0.9 },
  laser: { set: 'laser', n: 4, gain: 0.75 },
  plasma: { set: 'plasma', n: 3, gain: 0.8 },
  railgun: { set: 'railgun', n: 3, gain: 0.85 },
  spawn: { set: 'spawn', n: 2, gain: 0.6 },
  // guns: Vincent Sevedge, "Gunshot Sounds" (OpenGameArt), credited in public/sfx/CREDITS.txt
  rifle: { set: 'rifle', n: 5, gain: 0.8 },
  musket: { set: 'musket', n: 5, rate: 0.9, gain: 0.85 },
  mg: { set: 'mg', n: 4, rate: 1.12, gain: 0.7 },
  pistol: { set: 'pistol', n: 4, gain: 0.75 },
  cannon: { set: 'cannon', n: 1, rate: 0.55, gain: 1 },
};
/** every file to load, deduplicated (sets are shared between names) */
export function sampleFiles() {
  const out = new Set();
  for (const s of Object.values(SAMPLE_SETS)) for (let i = 0; i < s.n; i++) out.add(`${s.set}_${i}.m4a`);
  return [...out];
}
